module.exports = __webpack_public_path__ + "img/whats-next.848576a6.jpg";